$(document).ready(function () {
    $(".card-carousel-slides").each(function () {
        var $this = $(this);
        var $slides = $this.children(".card-carousel-slide");
        if ($slides.length > 3 && !$("body").hasClass("experience-editor"))
        {
            $this.slick({
                infinite: false,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerMode: true,
                            //centerPadding: "50px",
                            slidesToShow: 1
                        }
                    }
                ],
                slidesToShow: 3,
                slidesToScroll: 1
            });
        }
        else {
            $this.addClass("no-carousel");
        }
    });
});